export default function notifyApi (referrer) {
  let clientId = null
  const windowLocation = { ...window.location }
  const path = windowLocation.pathname
  const pageUrl = windowLocation.href
  function notify () {
    if (!clientId) {
      if (!window.gtag) setTimeout(notify, 100)
      else {
        window.gtag('get', 'G-VRPMCST53D', 'client_id', (cid) => {
          clientId = cid
          notify(referrer)
        })
      }
    } else {
      const url = pageUrl ? new URL(pageUrl) : new URL(window.location.href)
      const data = {
        event_name: 'view_page',
        path: path || window.location.pathname,
        url: pageUrl || window.location.href,
        referrer: referrer || document.referrer,
        google_id: clientId,
        timestamp: Math.floor(Date.now() / 1000),
        utm_source: url.searchParams.get('utm_source') || '',
        utm_medium: url.searchParams.get('utm_medium') || '',
        utm_campaign: url.searchParams.get('utm_campaign') || '',
        utm_term: url.searchParams.get('utm_term') || '',
        utm_content: url.searchParams.get('utm_content') || ''
      }
      const xhr = new XMLHttpRequest()
      xhr.open('POST', '/api/v1/events/?action=pushevent')
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
      xhr.setRequestHeader('Qic-Product-Code', 'qarenew')
      xhr.send(new URLSearchParams(data).toString())
    }
  }
  notify()
}
